export default __webpack_public_path__ + "static/media/warning--cliff--g2.b11bf115.png";